module.exports = __webpack_public_path__ + "static/img/home_img_dinghuoxitong.f9bc211.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_img_dinghuoxitong.png
// module id = afqG
// module chunks = 1